export const lomiaInitTerritories = {
    '04016': {
        name: 'Authon',
        latitude: 44.23820635164004,
        longitude: 6.126518697418387,
    },
    '04023': {
        name: 'Bayons',
        latitude: 44.33770201342988,
        longitude: 6.162265232847884,
    },
    '04026': {
        name: 'Bellaffaire',
        latitude: 44.41925154554571,
        longitude: 6.175940660377155,
    },
    '04037': {
        name: 'Le Caire',
        latitude: 44.3689004278536,
        longitude: 6.058959693194664,
    },
    '04050': {
        name: 'Châteaufort',
        latitude: 44.27469900734565,
        longitude: 6.017240941886407,
    },
    '04057': {
        name: 'Clamensane',
        latitude: 44.32308078384638,
        longitude: 6.06971688982091,
    },
    '04058': {
        name: 'Claret',
        latitude: 44.37213736828237,
        longitude: 5.956326167214455,
    },
    '04066': {
        name: 'Curbans',
        latitude: 44.42730181684595,
        longitude: 6.03583927450241,
    },
    '04075': {
        name: 'Entrepierres',
        latitude: 44.18699144302769,
        longitude: 5.993823021612341,
    },
    '04085': {
        name: 'Faucon-du-Caire',
        latitude: 44.39665885390416,
        longitude: 6.091054229497693,
    },
    '04093': {
        name: 'Gigors',
        latitude: 44.41873404747709,
        longitude: 6.160422550159861,
    },
    '04118': {
        name: 'Melve',
        latitude: 44.35466068178344,
        longitude: 5.989969665675535,
    },
    '04123': {
        name: 'Mison',
        latitude: 44.26802597562332,
        longitude: 5.858768856382594,
    },
    '04134': {
        name: 'La Motte-du-Caire',
        latitude: 44.34271015964529,
        longitude: 6.027852034052557,
    },
    '04137': {
        name: 'Nibles',
        latitude: 44.28172417110789,
        longitude: 6.018586561481319,
    },
    '04150': {
        name: 'Piégut',
        latitude: 44.4518585424573,
        longitude: 6.128420971401135,
    },
    '04154': {
        name: 'Pontis',
        latitude: 44.50422656109887,
        longitude: 6.357655346725704,
    },
    '04179': {
        name: 'Saint-Geniez',
        latitude: 44.24506550991903,
        longitude: 6.053046046048075,
    },
    '04207': {
        name: 'Sigoyer',
        latitude: 44.31967970705912,
        longitude: 5.957984455963412,
    },
    '04209': {
        name: 'Sisteron',
        latitude: 44.19461278716033,
        longitude: 5.942984095755595,
    },
    '04216': {
        name: 'Thèze',
        latitude: 44.31934288314501,
        longitude: 5.922144499962427,
    },
    '04222': {
        name: 'Turriers',
        latitude: 44.40120024302033,
        longitude: 6.168336330523612,
    },
    '04228': {
        name: 'Valavoire',
        latitude: 44.27910331725284,
        longitude: 6.066319094014212,
    },
    '04231': {
        name: 'Valernes',
        latitude: 44.26194000297697,
        longitude: 5.960725204583032,
    },
    '04233': {
        name: 'Vaumeilh',
        latitude: 44.28850258791428,
        longitude: 5.957875125931665,
    },
    '04234': {
        name: 'Venterol',
        latitude: 44.44505288857948,
        longitude: 6.099328930415651,
    },
    '05001': {
        name: 'Abriès-Ristolas',
        latitude: 44.79398302594539,
        longitude: 6.927668317676901,
    },
    '05003': {
        name: 'Aiguilles',
        latitude: 44.78187458909206,
        longitude: 6.869407570720684,
    },
    '05004': {
        name: 'Ancelle',
        latitude: 44.62484617344913,
        longitude: 6.206174751772299,
    },
    '05006': {
        name: 'L\'Argentière-la-Bessée',
        latitude: 44.79296076928267,
        longitude: 6.559272955215998,
    },
    '05007': {
        name: 'Arvieux',
        latitude: 44.76708594894236,
        longitude: 6.738807988450329,
    },
    '05008': {
        name: 'Aspremont',
        latitude: 44.49278467204078,
        longitude: 5.728281460809574,
    },
    '05009': {
        name: 'Aspres-lès-Corps',
        latitude: 44.80172103608098,
        longitude: 5.982148538386533,
    },
    '05010': {
        name: 'Aspres-sur-Buëch',
        latitude: 44.52318354556561,
        longitude: 5.749574623873265,
    },
    '05011': {
        name: 'Avançon',
        latitude: 44.52484487318496,
        longitude: 6.184461220992234,
    },
    '05012': {
        name: 'Baratier',
        latitude: 44.53891223139927,
        longitude: 6.495496503511031,
    },
    '05013': {
        name: 'Barcillonnette',
        latitude: 44.4342550970451,
        longitude: 5.91914613794594,
    },
    '05014': {
        name: 'Barret-sur-Méouge',
        latitude: 44.26217182994393,
        longitude: 5.731553827199411,
    },
    '05016': {
        name: 'La Bâtie-Montsaléon',
        latitude: 44.45617751533127,
        longitude: 5.749737671037821,
    },
    '05017': {
        name: 'La Bâtie-Neuve',
        latitude: 44.56525378897965,
        longitude: 6.19777978275048,
    },
    '05018': {
        name: 'La Bâtie-Vieille',
        latitude: 44.55358212517459,
        longitude: 6.162773623011141,
    },
    '05019': {
        name: 'La Beaume',
        latitude: 44.55257927792096,
        longitude: 5.636528120364316,
    },
    '05021': {
        name: 'Le Bersac',
        latitude: 44.4118802227451,
        longitude: 5.75038700525539,
    },
    '05022': {
        name: 'Bréziers',
        latitude: 44.42609173796649,
        longitude: 6.199517617965105,
    },
    '05023': {
        name: 'Briançon',
        latitude: 44.89823233782202,
        longitude: 6.643555637882276,
    },
    '05024': {
        name: 'Valdoule',
        latitude: 44.46806242324631,
        longitude: 5.51224694374608,
    },
    '05025': {
        name: 'Buissard',
        latitude: 44.65661542630892,
        longitude: 6.142350462780673,
    },
    '05026': {
        name: 'Ceillac',
        latitude: 44.66825631194376,
        longitude: 6.778101578590769,
    },
    '05027': {
        name: 'Cervières',
        latitude: 44.87081811226652,
        longitude: 6.722151702431209,
    },
    '05028': {
        name: 'Chabestan',
        latitude: 44.47788341261936,
        longitude: 5.782563349337045,
    },
    '05029': {
        name: 'Chabottes',
        latitude: 44.64342632368364,
        longitude: 6.170671798234502,
    },
    '05031': {
        name: 'Champcella',
        latitude: 44.7235708089234,
        longitude: 6.571847034862296,
    },
    '05032': {
        name: 'Champoléon',
        latitude: 44.7201065150531,
        longitude: 6.260160566345705,
    },
    '05033': {
        name: 'Chanousse',
        latitude: 44.35542768362671,
        longitude: 5.6561194516403,
    },
    '05035': {
        name: 'Châteauneuf-d\'Oze',
        latitude: 44.5114304554718,
        longitude: 5.865613989123544,
    },
    '05036': {
        name: 'Châteauroux-les-Alpes',
        latitude: 44.61389322671094,
        longitude: 6.521233027289898,
    },
    '05037': {
        name: 'Châteauvieux',
        latitude: 44.48544104961148,
        longitude: 6.049413266004599,
    },
    '05038': {
        name: 'Château-Ville-Vieille',
        latitude: 44.7568422129112,
        longitude: 6.791674145695448,
    },
    '05039': {
        name: 'Aubessagne',
        latitude: 44.75627656158518,
        longitude: 6.006854940372144,
    },
    '05040': {
        name: 'Chorges',
        latitude: 44.54576256900793,
        longitude: 6.275120307426245,
    },
    '05044': {
        name: 'Crévoux',
        latitude: 44.54802493327738,
        longitude: 6.607942078246022,
    },
    '05045': {
        name: 'Crots',
        latitude: 44.53373068717463,
        longitude: 6.47132894492307,
    },
    '05046': {
        name: 'Embrun',
        latitude: 44.56381752756587,
        longitude: 6.495803156791801,
    },
    '05047': {
        name: 'Éourres',
        latitude: 44.21275946182612,
        longitude: 5.698071756757236,
    },
    '05048': {
        name: 'L\'Épine',
        latitude: 44.41569971707531,
        longitude: 5.613526523849675,
    },
    '05049': {
        name: 'Esparron',
        latitude: 44.45358575055256,
        longitude: 5.903113328983134,
    },
    '05050': {
        name: 'Espinasses',
        latitude: 44.46747248019471,
        longitude: 6.222741685210185,
    },
    '05051': {
        name: 'Étoile-Saint-Cyrice',
        latitude: 44.31570379003553,
        longitude: 5.627762805706618,
    },
    '05052': {
        name: 'Eygliers',
        latitude: 44.67503357972513,
        longitude: 6.616598991749103,
    },
    '05053': {
        name: 'Garde-Colombe',
        latitude: 44.34610448746363,
        longitude: 5.770637098512446,
    },
    '05054': {
        name: 'La Fare-en-Champsaur',
        latitude: 44.67575113564546,
        longitude: 6.071510164364123,
    },
    '05055': {
        name: 'La Faurie',
        latitude: 44.56680996036908,
        longitude: 5.738923445219764,
    },
    '05056': {
        name: 'Forest-Saint-Julien',
        latitude: 44.63380573171117,
        longitude: 6.134719075687454,
    },
    '05057': {
        name: 'Fouillouse',
        latitude: 44.45779539522847,
        longitude: 6.003277404689642,
    },
    '05058': {
        name: 'Freissinières',
        latitude: 44.75229668217897,
        longitude: 6.536427755253429,
    },
    '05059': {
        name: 'La Freissinouse',
        latitude: 44.53584778581328,
        longitude: 6.010533475537693,
    },
    '05060': {
        name: 'Furmeyer',
        latitude: 44.53635418252235,
        longitude: 5.853659919076556,
    },
    '05061': {
        name: 'Gap',
        latitude: 44.55869047407503,
        longitude: 6.079776708318203,
    },
    '05062': {
        name: 'Le Glaizil',
        latitude: 44.7549057873159,
        longitude: 5.982242917336153,
    },
    '05063': {
        name: 'La Grave',
        latitude: 45.04609750934125,
        longitude: 6.307087670283105,
    },
    '05064': {
        name: 'La Chapelle-en-Valgaudémar',
        latitude: 44.81681154106763,
        longitude: 6.195483017200034,
    },
    '05065': {
        name: 'Guillestre',
        latitude: 44.66101793273342,
        longitude: 6.649368848447559,
    },
    '05066': {
        name: 'La Haute-Beaume',
        latitude: 44.5645149744992,
        longitude: 5.630637330326721,
    },
    '05068': {
        name: 'Jarjayes',
        latitude: 44.50551785648602,
        longitude: 6.109756151719944,
    },
    '05070': {
        name: 'Laragne-Montéglin',
        latitude: 44.31517112152706,
        longitude: 5.821688484916462,
    },
    '05071': {
        name: 'Lardier-et-Valença',
        latitude: 44.43482057898248,
        longitude: 5.980412053641994,
    },
    '05072': {
        name: 'Laye',
        latitude: 44.66069700306935,
        longitude: 6.084329119343721,
    },
    '05073': {
        name: 'Lazer',
        latitude: 44.34535840741498,
        longitude: 5.840739975819414,
    },
    '05074': {
        name: 'Lettret',
        latitude: 44.46806205972239,
        longitude: 6.061409569883536,
    },
    '05075': {
        name: 'Manteyer',
        latitude: 44.53817203594349,
        longitude: 5.964179289187606,
    },
    '05076': {
        name: 'Méreuil',
        latitude: 44.38740012317378,
        longitude: 5.729483369623921,
    },
    '05077': {
        name: 'Molines-en-Queyras',
        latitude: 44.73078677708231,
        longitude: 6.842910858746694,
    },
    '05078': {
        name: 'Monêtier-Allemont',
        latitude: 44.38614596736276,
        longitude: 5.943948541528562,
    },
    '05079': {
        name: 'Le Monêtier-les-Bains',
        latitude: 44.97645252139093,
        longitude: 6.508036376254332,
    },
    '05080': {
        name: 'Montbrand',
        latitude: 44.59167416115427,
        longitude: 5.681846809334935,
    },
    '05081': {
        name: 'Montclus',
        latitude: 44.41491858345613,
        longitude: 5.683015006532314,
    },
    '05082': {
        name: 'Mont-Dauphin',
        latitude: 44.6693200478935,
        longitude: 6.625921190252301,
    },
    '05084': {
        name: 'Montgardin',
        latitude: 44.54994336122959,
        longitude: 6.240135767479162,
    },
    '05085': {
        name: 'Montgenèvre',
        latitude: 44.93300650602526,
        longitude: 6.727293073852217,
    },
    '05086': {
        name: 'Montjay',
        latitude: 44.36020935335277,
        longitude: 5.603516027603821,
    },
    '05087': {
        name: 'Montmaur',
        latitude: 44.57077452026964,
        longitude: 5.874745352040897,
    },
    '05089': {
        name: 'Montrond',
        latitude: 44.38218734072021,
        longitude: 5.741892044885113,
    },
    '05090': {
        name: 'La Motte-en-Champsaur',
        latitude: 44.7318766758867,
        longitude: 6.066681070655282,
    },
    '05091': {
        name: 'Moydans',
        latitude: 44.39971509696678,
        longitude: 5.503985742460597,
    },
    '05092': {
        name: 'Neffes',
        latitude: 44.50463699591705,
        longitude: 6.023010455697376,
    },
    '05093': {
        name: 'Névache',
        latitude: 45.01913696711721,
        longitude: 6.613009000635437,
    },
    '05094': {
        name: 'Nossage-et-Bénévent',
        latitude: 44.31486486483055,
        longitude: 5.748774714328312,
    },
    '05095': {
        name: 'Le Noyer',
        latitude: 44.69853083134684,
        longitude: 6.01196716314996,
    },
    '05096': {
        name: 'Orcières',
        latitude: 44.68451675955512,
        longitude: 6.324579612685071,
    },
    '05097': {
        name: 'Orpierre',
        latitude: 44.31396179874672,
        longitude: 5.693452921846387,
    },
    '05098': {
        name: 'Les Orres',
        latitude: 44.51415572623008,
        longitude: 6.551045585369375,
    },
    '05099': {
        name: 'Oze',
        latitude: 44.50534110179056,
        longitude: 5.804279652830044,
    },
    '05100': {
        name: 'Pelleautier',
        latitude: 44.51598769886144,
        longitude: 6.017628576867423,
    },
    '05101': {
        name: 'Vallouise-Pelvoux',
        latitude: 44.86893303053642,
        longitude: 6.487314770981819,
    },
    '05102': {
        name: 'La Piarre',
        latitude: 44.47597860251913,
        longitude: 5.656172113832847,
    },
    '05103': {
        name: 'Le Poët',
        latitude: 44.29205870957313,
        longitude: 5.897565623021499,
    },
    '05104': {
        name: 'Poligny',
        latitude: 44.69139289094381,
        longitude: 6.047133048651133,
    },
    '05106': {
        name: 'Prunières',
        latitude: 44.54202471581951,
        longitude: 6.333091186345229,
    },
    '05107': {
        name: 'Puy-Saint-André',
        latitude: 44.87847836302045,
        longitude: 6.597086777906059,
    },
    '05108': {
        name: 'Puy-Saint-Eusèbe',
        latitude: 44.5683891333135,
        longitude: 6.40185694248724,
    },
    '05109': {
        name: 'Puy-Saint-Pierre',
        latitude: 44.89095643864163,
        longitude: 6.623748458358348,
    },
    '05110': {
        name: 'Puy-Saint-Vincent',
        latitude: 44.82872337468628,
        longitude: 6.492935409707826,
    },
    '05111': {
        name: 'Puy-Sanières',
        latitude: 44.55648507898547,
        longitude: 6.436468045375069,
    },
    '05112': {
        name: 'Rabou',
        latitude: 44.59076307538623,
        longitude: 6.005060732121818,
    },
    '05113': {
        name: 'Rambaud',
        latitude: 44.54477009326475,
        longitude: 6.132060591199046,
    },
    '05114': {
        name: 'Réallon',
        latitude: 44.59572700846074,
        longitude: 6.362991895943304,
    },
    '05115': {
        name: 'Remollon',
        latitude: 44.46805944939056,
        longitude: 6.167974428088767,
    },
    '05116': {
        name: 'Réotier',
        latitude: 44.66587118037124,
        longitude: 6.58893029861192,
    },
    '05117': {
        name: 'Ribeyret',
        latitude: 44.41328803611499,
        longitude: 5.554787584826825,
    },
    '05118': {
        name: 'Val Buëch-Méouge',
        latitude: 44.23007838265075,
        longitude: 5.857563810564573,
    },
    '05119': {
        name: 'Risoul',
        latitude: 44.64833746662841,
        longitude: 6.63660180131125,
    },
    '05121': {
        name: 'Rochebrune',
        latitude: 44.45638772740313,
        longitude: 6.176931621872672,
    },
    '05122': {
        name: 'La Roche-de-Rame',
        latitude: 44.74991217438661,
        longitude: 6.580148600342559,
    },
    '05123': {
        name: 'La Roche-des-Arnauds',
        latitude: 44.5634536945797,
        longitude: 5.958415478445592,
    },
    '05124': {
        name: 'La Rochette',
        latitude: 44.59373175705338,
        longitude: 6.15143027396953,
    },
    '05126': {
        name: 'Rosans',
        latitude: 44.39164263899499,
        longitude: 5.470146504183341,
    },
    '05127': {
        name: 'Rousset-Serre-Ponçon',
        latitude: 44.46766975128665,
        longitude: 6.232863433369586,
    },
    '05128': {
        name: 'Saint-André-d\'Embrun',
        latitude: 44.58664966160133,
        longitude: 6.5347724089759,
    },
    '05129': {
        name: 'Saint-André-de-Rosans',
        latitude: 44.37711516730059,
        longitude: 5.514439624193715,
    },
    '05130': {
        name: 'Saint-Apollinaire',
        latitude: 44.55629319457495,
        longitude: 6.362599950132733,
    },
    '05131': {
        name: 'Saint-Auban-d\'Oze',
        latitude: 44.49571034865568,
        longitude: 5.84715036421714,
    },
    '05132': {
        name: 'Saint-Bonnet-en-Champsaur',
        latitude: 44.68282801140786,
        longitude: 6.07799960580825,
    },
    '05133': {
        name: 'Saint-Chaffrey',
        latitude: 44.9261060890512,
        longitude: 6.607138584359309,
    },
    '05134': {
        name: 'Saint-Clément-sur-Durance',
        latitude: 44.64774138821807,
        longitude: 6.577485262831544,
    },
    '05135': {
        name: 'Sainte-Colombe',
        latitude: 44.28510886310038,
        longitude: 5.669219715020718,
    },
    '05136': {
        name: 'Saint-Crépin',
        latitude: 44.70657868125929,
        longitude: 6.607258930832812,
    },
    '05139': {
        name: 'Dévoluy',
        latitude: 44.68764921663956,
        longitude: 5.945412019843458,
    },
    '05140': {
        name: 'Saint-Étienne-le-Laus',
        latitude: 44.5027851148486,
        longitude: 6.161506515233743,
    },
    '05142': {
        name: 'Saint-Firmin',
        latitude: 44.78125659912033,
        longitude: 6.029846046640812,
    },
    '05144': {
        name: 'Saint-Jacques-en-Valgodemard',
        latitude: 44.77305780925833,
        longitude: 6.031489928899304,
    },
    '05145': {
        name: 'Saint-Jean-Saint-Nicolas',
        latitude: 44.66778898826116,
        longitude: 6.227928631749941,
    },
    '05146': {
        name: 'Saint-Julien-en-Beauchêne',
        latitude: 44.61749581125503,
        longitude: 5.708106939534171,
    },
    '05147': {
        name: 'Saint-Julien-en-Champsaur',
        latitude: 44.65977845737037,
        longitude: 6.129208808072002,
    },
    '05148': {
        name: 'Saint-Laurent-du-Cros',
        latitude: 44.64362979963947,
        longitude: 6.112820781679203,
    },
    '05149': {
        name: 'Saint-Léger-les-Mélèzes',
        latitude: 44.64421944686819,
        longitude: 6.199868836987022,
    },
    '05151': {
        name: 'Saint-Martin-de-Queyrières',
        latitude: 44.84105802315073,
        longitude: 6.585215029519098,
    },
    '05152': {
        name: 'Saint-Maurice-en-Valgodemard',
        latitude: 44.80415048023663,
        longitude: 6.096174254821864,
    },
    '05153': {
        name: 'Saint-Michel-de-Chaillol',
        latitude: 44.68162406422307,
        longitude: 6.167439103750082,
    },
    '05154': {
        name: 'Saint-Pierre-d\'Argençon',
        latitude: 44.51972021698659,
        longitude: 5.699159021249788,
    },
    '05155': {
        name: 'Saint-Pierre-Avez',
        latitude: 44.25622802584491,
        longitude: 5.761604460148211,
    },
    '05156': {
        name: 'Saint-Sauveur',
        latitude: 44.54124838843783,
        longitude: 6.519830305182359,
    },
    '05157': {
        name: 'Saint-Véran',
        latitude: 44.70061558380298,
        longitude: 6.868487339955402,
    },
    '05158': {
        name: 'Le Saix',
        latitude: 44.47503283005815,
        longitude: 5.824942782324588,
    },
    '05159': {
        name: 'Saléon',
        latitude: 44.33200925087919,
        longitude: 5.775855676129097,
    },
    '05160': {
        name: 'Salérans',
        latitude: 44.24318482166018,
        longitude: 5.705961982166631,
    },
    '05161': {
        name: 'La Salle-les-Alpes',
        latitude: 44.94438981996685,
        longitude: 6.56640357050208,
    },
    '05162': {
        name: 'La Saulce',
        latitude: 44.42515429987677,
        longitude: 6.007994174621375,
    },
    '05163': {
        name: 'Le Sauze-du-Lac',
        latitude: 44.47802508635574,
        longitude: 6.314807197313648,
    },
    '05164': {
        name: 'Savines-le-Lac',
        latitude: 44.5259308922185,
        longitude: 6.404947576380597,
    },
    '05165': {
        name: 'Savournon',
        latitude: 44.42165105775708,
        longitude: 5.79387784230973,
    },
    '05166': {
        name: 'Serres',
        latitude: 44.42833178435053,
        longitude: 5.714634076787277,
    },
    '05167': {
        name: 'Sigottier',
        latitude: 44.45489874239017,
        longitude: 5.691865338418463,
    },
    '05168': {
        name: 'Sigoyer',
        latitude: 44.47709985460822,
        longitude: 5.976372360351356,
    },
    '05169': {
        name: 'Sorbiers',
        latitude: 44.37515155737653,
        longitude: 5.56379290266324,
    },
    '05170': {
        name: 'Tallard',
        latitude: 44.46361297040458,
        longitude: 6.056950668682255,
    },
    '05171': {
        name: 'Théus',
        latitude: 44.47548482859189,
        longitude: 6.189688590505244,
    },
    '05172': {
        name: 'Trescléoux',
        latitude: 44.3545225410882,
        longitude: 5.70842607416845,
    },
    '05173': {
        name: 'Upaix',
        latitude: 44.31391696703175,
        longitude: 5.890518770239946,
    },
    '05174': {
        name: 'Val-des-Prés',
        latitude: 44.94971743635935,
        longitude: 6.678373861223691,
    },
    '05176': {
        name: 'Valserres',
        latitude: 44.48711580204445,
        longitude: 6.125685341416551,
    },
    '05177': {
        name: 'Vars',
        latitude: 44.59382260958092,
        longitude: 6.689886766589104,
    },
    '05178': {
        name: 'Ventavon',
        latitude: 44.37071689299365,
        longitude: 5.906006914439604,
    },
    '05179': {
        name: 'Veynes',
        latitude: 44.53489147613502,
        longitude: 5.824380270205076,
    },
    '05180': {
        name: 'Les Vigneaux',
        latitude: 44.82351505441788,
        longitude: 6.542116846096521,
    },
    '05181': {
        name: 'Villar-d\'Arêne',
        latitude: 45.04291657448351,
        longitude: 6.335230872247556,
    },
    '05182': {
        name: 'Villar-Loubière',
        latitude: 44.82598246712415,
        longitude: 6.145596115208465,
    },
    '05183': {
        name: 'Villar-Saint-Pancrace',
        latitude: 44.87454593905089,
        longitude: 6.628430549422098,
    },
    '05184': {
        name: 'Vitrolles',
        latitude: 44.41317707987913,
        longitude: 5.952230997120287,
    },
    '26153': {
        name: 'Laborel',
        latitude: 44.29237682116671,
        longitude: 5.595420639609396,
    },
    '26154': {
        name: 'Lachau',
        latitude: 44.23162369201483,
        longitude: 5.638012617517343,
    },
    '26374': {
        name: 'Villebois-les-Pins',
        latitude: 44.31707967430536,
        longitude: 5.61178719599619,
    },
};